// @ts-nocheck
import React from 'react';
import _ from 'lodash';
import { IconButton, withStyles } from '@material-ui/core';
import { Entity, ctx as L20NContext } from '@sketchpixy/rubix/lib/L20n';
import MDButton from '../MDButton/MDButton.jsx';
import Warning from '@material-ui/icons/Warning';
import Cancel from '@material-ui/icons/Cancel';
import ErrorOutline from '@material-ui/icons/ErrorOutline';
import {
  FormControl, FormGroup
} from '@sketchpixy/rubix';
import { ORANGE, RED } from '../../_config/consts';


const styles = theme => ({
  viewContainer: {
    margin: 13,
    marginBottom: 30,
    padding: 10,
  },
  headerContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
  },
  warningTitleContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: 20,
    marginTop: 20,
  },
  titleText: {
    marginRight: 5,
    marginBottom: 5,
    fontSize: 25,
    fontWeight: 'bold',
    color: '#3f3f3f',
    textAlign: 'left',
  },
  warningBox: {
    padding: 20,
    borderRadius: 10,
    backgroundColor: '#fff3e0',
    border: `2px solid ${ORANGE}`,
    marginBottom: 20,
  },
  dangerBox: {
    padding: 20,
    borderRadius: 10,
    backgroundColor: '#ffebee',
    border: `2px solid ${RED}`,
    marginBottom: 20,
  },
  infoBox: {
    padding: 15,
    borderRadius: 10,
    backgroundColor: '#f5f5f5',
    marginBottom: 20,
  },
  sectionTitle: {
    margin: 0,
    marginBottom: 10,
    fontSize: 18,
    fontWeight: 'bold',
    color: '#3f3f3f',
    display: 'flex',
    alignItems: 'center',
  },
  sectionText: {
    margin: 0,
    marginRight: 5,
    fontSize: 16,
    lineHeight: 1.6,
    color: '#3f3f3f',
    textAlign: 'left',
  },
  bulletList: {
    margin: 0,
    marginTop: 10,
    paddingLeft: 20,
  },
  bulletItem: {
    fontSize: 15,
    lineHeight: 1.8,
    color: '#3f3f3f',
  },
  warningIcon: {
    color: ORANGE,
    fontSize: 30,
    marginRight: 10,
  },
  dangerIcon: {
    color: RED,
    fontSize: 24,
    marginRight: 8,
  },
  italicText: {
    fontStyle: 'italic',
    fontWeight: 'bold',
    color: RED,
    backgroundColor: '#ffebee',
    padding: '2px 8px',
    borderRadius: 4,
    marginLeft: 5,
  },
  confirmationInputContainer: {
    marginTop: 20,
    padding: 15,
    borderRadius: 10,
    backgroundColor: '#fafafa',
    border: '1px solid #e0e0e0',
  },
  feedbackContainer: {
    marginTop: 20,
  },
});

class WalletSubscriptionRemoveView extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      deleteText: undefined,
      feedbackText: undefined,
      hasInputError: false,
    };
  }

  onChangeText(deleteText) {
    this.setState({ deleteText });
    setTimeout(() => this.onValidateInput(), 500);
  }

  onValidateInput() {
    const { deleteText } = this.state;
    const validationString = L20NContext.getSync('deletePermanentlyText');
    const isValid = validationString === _.trim(deleteText.toLowerCase());
    this.setState({ hasInputError: !isValid });
    return isValid;
  }

  onChangeFeedbackText(feedbackText) {
    this.setState({ feedbackText });
  }

  onSubmitForm() {
    const { feedbackText } = this.state;
    const { onRemoveSubscriptionConfirm } = this.props;
    const isValid = this.onValidateInput();
    if (isValid && onRemoveSubscriptionConfirm) {
      onRemoveSubscriptionConfirm(feedbackText);
    }
  }

  render() {
    const { classes, onCloseModal } = this.props;
    const { hasInputError, feedbackText, deleteText } = this.state;
    return (
      <div className={classes.viewContainer}>
        <input style={{ display: 'none' }} type="text" name="deleteInput" />
        {/* Warning Title */}
        <div className={classes.warningTitleContainer}>
          <Warning style={{ color: ORANGE, fontSize: 35 }} />
          <h2 className={classes.titleText} style={{ margin: 0, marginLeft: 10 }}>
            <Entity entity="warning" />
          </h2>
        </div>

        {/* Danger Warning Box */}
        <div className={classes.dangerBox}>
          <h3 className={classes.sectionTitle}>
            <ErrorOutline className={classes.dangerIcon} />
            <Entity entity="deleteSubscriptionExplanation" />
          </h3>
        </div>

        {/* Confirmation Input Section */}
        <div className={classes.confirmationInputContainer}>
          <h3 className={classes.sectionTitle} style={{ marginBottom: 15 }}>
            <Entity entity="deleteConfirmInsertInput" />
            <span className={classes.italicText}>
              <Entity entity="deletePermanentlyText" />
            </span>
          </h3>
          <FormGroup
            controlId="formBasicText"
            validationState={hasInputError ? 'error' : 'success'}
          >
            <FormControl
              name="deleteInput"
              type="text"
              value={deleteText}
              onPaste={e => e.preventDefault()}
              onChange={e => this.onChangeText(e.target.value)}
              style={{ 
                fontSize: 16, 
                padding: 12,
                borderColor: hasInputError ? RED : '#e0e0e0',
                borderWidth: 2,
              }}
            />
            {hasInputError ? (
              <h6 style={{ color: RED, marginTop: 8, fontWeight: 'bold' }}>
                <Entity entity="errorInputCoincide" />
              </h6>
            ) : null}
          </FormGroup>
        </div>

        {/* Feedback Section */}
        <div className={classes.feedbackContainer}>
          <div className={classes.infoBox}>
            <h3 className={classes.sectionTitle} style={{ marginBottom: 10 }}>
              <Entity entity="leaveUsAFeedback" />
            </h3>
            <FormGroup
              controlId="feedbackArea"
              validationState="success"
            >
              <FormControl
                type="text"
                componentClass="textarea"
                value={feedbackText}
                style={{ 
                  height: 120, 
                  fontSize: 14,
                  resize: 'vertical',
                }}
                placeholder={L20NContext.getSync('leaveUsAFeedbackPlaceholder')}
                onChange={e => this.onChangeFeedbackText(e.target.value)}
              />
            </FormGroup>
          </div>
        </div>

        {/* Submit Button */}
        <MDButton
          containerStyle={{ marginTop: 30 }}
          title={<Entity entity="removeSubscription" />}
          backgroundColor={RED}
          disabled={hasInputError || !deleteText}
          onClick={() => this.onSubmitForm()}
        />
      </div>
    );
  }
}
export default withStyles(styles)(WalletSubscriptionRemoveView);
